import { FieldValidator } from 'final-form';
import React from 'react';
import { Field } from 'react-final-form';

export interface FieldsGroupInterface<Value = any> {
  name: string;
  children: any;
  onChange?: (() => Promise<void> | void) | null;
  reset?: boolean;
  validate?: FieldValidator<Value>;
}

interface FieldsGroupContextInterface {
  groupName?: string;
  groupOnChange?: (() => Promise<void>) | null;
  onChange?: () => void;
}

export const FieldsGroupContext =
  React.createContext<FieldsGroupContextInterface>({});

const FieldsGroup: React.SFC<FieldsGroupInterface> = ({
  name,
  children,
  onChange,
  reset,
  validate,
}) => (
  <FieldsGroupContext.Consumer>
    {({ groupName, groupOnChange }) => {
      const currentName = groupName && !reset ? `${groupName}.${name}` : name;

      const currentOnInputChange =
        onChange || groupOnChange
          ? async () => {
              if (typeof groupOnChange === 'function') {
                await groupOnChange();
              }
              if (typeof onChange === 'function') {
                await onChange();
              }
            }
          : null;
      return (
        <FieldsGroupContext.Provider
          value={{
            groupName: currentName,
            groupOnChange: currentOnInputChange,
          }}
        >
          {/* TODO: find a better way to handle fields groupd validation and initial values */}
          {validate ? (
            <Field name={currentName} validate={validate}>
              {() => null}
            </Field>
          ) : null}
          {children}
        </FieldsGroupContext.Provider>
      );
    }}
  </FieldsGroupContext.Consumer>
);

export default FieldsGroup;
